import { ContentItem } from '..';

export class DocumentContentItem extends ContentItem {
  private _documentUrl: string = '';
  private _documentString: string = '';
  extension: string = '';
  title: string = '';

  set type(type: string) {
    this._type = type;
  }

  get type() {
    return this._type;
  }

  constructor(json: any) {
    super();
    this._type = json.content_type;
    if (json.url) this.documentUrl = json.url;
    if (json.title) this.title = json.title;
    if (json.pdfString) this.documentString = json.pdfString;
    if (json.spreadsheetString) this.documentString = json.spreadsheetString;
  }

  get documentUrl() { return this._documentUrl; }

  get documentString() {
    return this._documentString;
  }

  set documentString(name: string) {
    this._documentString = name;
    if (name) {
      let ext = this.documentString.split('.');
      this.extension = ext[ext.length - 1].toUpperCase();
      this._type = this.extension === 'PDF' ? 'pdf' : 'spreadsheet';
    }
  }

  set documentUrl(url: string) {
    this._documentUrl = url;
    if (this.documentUrl) {
      let splitUrl = this.documentUrl.split('%2F');
      if (splitUrl.length && splitUrl[2]) {
        this.documentString = splitUrl[2].replace(/\+/g, ' ');
      }
    } else {
      this.documentString = '';
    }
  }

  copy() {
    return new DocumentContentItem(this.toJson());
  }

  toJson() {
    if (this.type === 'pdf') {
      return {
        content_type: 'pdf',
        url: this.documentUrl,
        title: this.title,
        pdfString: this.documentString
      };
    } else if (this.type === 'spreadsheet') {
      return {
        content_type: 'spreadsheet',
        url: this.documentUrl,
        title: this.title,
        spreadsheetString: this.documentString
      };
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/document-content-item.model.ts